document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('el-cart-drawer');
  if (!drawer) return;

  var body = drawer.querySelector('[data-cart-drawer-body]');
  var closeTriggers = drawer.querySelectorAll('[data-cart-drawer-close]');
  var openTriggers = document.querySelectorAll('[data-cart-drawer-open]');

  function openDrawer(e) {
    if (e) e.preventDefault();
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  openTriggers.forEach(function (btn) {
    btn.addEventListener('click', openDrawer);
  });

  closeTriggers.forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  body.addEventListener('click', function (e) {
    var item = e.target.closest('.el-cart-item');
    if (!item) return;
    var key = item.getAttribute('data-cart-item-key');
    var qtyEl = item.querySelector('.el-cart-item__qty-value');
    var currentQty = parseInt(qtyEl.textContent, 10);

    if (e.target.matches('[data-cart-qty-increase]')) {
      changeQuantity(key, currentQty + 1, item, qtyEl);
    }
    if (e.target.matches('[data-cart-qty-decrease]')) {
      changeQuantity(key, Math.max(0, currentQty - 1), item, qtyEl);
    }
    if (e.target.matches('[data-cart-remove]')) {
      changeQuantity(key, 0, item, qtyEl);
    }
  });

  function changeQuantity(key, newQty, itemEl, qtyEl) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (newQty === 0) {
          itemEl.remove();
          if (cart.item_count === 0) {
            window.location.reload();
          }
        } else {
          qtyEl.textContent = newQty;
        }
        var cartCountEl = document.querySelector('.el-header__cart-count');
        if (cartCountEl) cartCountEl.textContent = cart.item_count;

        var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      })
      .catch(function (err) {
        console.error('Cart update failed', err);
      });
  }
});
